import script from "./ClubEventTournamentTypeEdit.vue?vue&type=script&setup=true&lang=js"
export * from "./ClubEventTournamentTypeEdit.vue?vue&type=script&setup=true&lang=js"

import "./ClubEventTournamentTypeEdit.vue?vue&type=style&index=0&id=f28d789a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-f28d789a"]])

export default __exports__